import React, { useEffect, useRef } from 'react';

interface SimpleEditorProps {
  className?: string;
  placeholder?: string;
}

export function SimpleEditor({ className = '', placeholder = 'Start writing...' }: SimpleEditorProps) {
  const editorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!editorRef.current) return;

    // For now, create a simple contentEditable div
    // We'll replace this with BlockSuite once we fix the API
    editorRef.current.innerHTML = `
      <div style="padding: 20px; min-height: 200px; border: 1px solid #e5e7eb; border-radius: 8px; font-family: ui-sans-serif, system-ui;">
        <p style="color: #9ca3af; margin: 0;">${placeholder}</p>
      </div>
    `;
  }, [placeholder]);

  return (
    <div className={`simple-editor ${className}`}>
      <div ref={editorRef} />
      <div className="mt-4 text-sm text-muted-foreground">
        <p>🚧 BlockSuite editor integration in progress</p>
        <p>Current: Simple contentEditable placeholder</p>
      </div>
    </div>
  );
}